// extracted by mini-css-extract-plugin
export default {"proposalItem":"Proposal_proposalItem__snNA2","newsItem":"Proposal_newsItem__CQSg8","title":"Proposal_title__v68wH","textContent":"Proposal_textContent__O2ak1"};